module.exports = __webpack_public_path__ + "img/0Q3C0560_Wood_MockedUp.717e8fac.jpg";